import { Component, ComponentRef, ElementRef,
  EventEmitter, HostListener, OnInit, Output,
  ViewChild, ViewContainerRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HtmlErrorComponent } from 'src/app/fragments/html-error/html-error.component';
import { ModalService } from 'src/app/services/modal/modal.service';
import { MssServiceFactory, MssTypeService } from 'src/app/services/mss/mss-service.factory';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-connect-to-apicrypt',
  templateUrl: './connect-to-apicrypt.component.html',
  styleUrls: [
    './connect-to-apicrypt.component.scss',
    '../../../../../fragments/modal/modal.fragment.scss'
  ]
})
export class ConnectToApicryptComponent implements OnInit {

  public inputAccount = '';
  public formGroup: FormGroup;

  @ViewChild('modalBody') public modalBody: ElementRef;
  @ViewChild('outsideModal') public outsideModal: ElementRef;

  @Output() public closeEmitter = new EventEmitter<string>();

  @HostListener('document:mousedown', ['$event'])
  onGlobalClick(event): void {
    if (!environment.closeModalOnClickOutside) {
      return;
    }

    if (!this.modalBody.nativeElement.contains(event.target) && this.outsideModal.nativeElement.contains(event.target)) {
        this.closeModal();
    }
  }

  constructor(
    private _modalSrv: ModalService,
    private _viewContainerRef: ViewContainerRef,
    private _mssSrv: MssServiceFactory,
    private _formBuilder: FormBuilder,
  ) { }

  ngOnInit(): void {
    this.formGroup = this._formBuilder.group({
      account: [this.inputAccount, [Validators.required]],
      password: ['', Validators.required]
    });
  }

  public closeModal(res?: string): void {
    this.closeEmitter.emit(res);
  }

  public async connectToApicrypt(): Promise<void> {
    const loading = this._modalSrv.openLoading(this._viewContainerRef);

    try {
      const login = {
        account: this.formGroup.get('account').value,
        password: this.formGroup.get('password').value
      };

      // On s'authentifie auprès de la MSS
      this._mssSrv.switchService(MssTypeService.apicrypt);
      await this._mssSrv.getService().connectToMSSByIDNAT(login.account, login.password);
      this.closeModal('connected');
    } catch (e) {
      if (e.code === 409) {
        this._openHTMLError(e.message);
      } else {
        console.error(e);
        this._openAlertModal(e.toString(), 'Une erreur est survenue lors de la connexion par identifiant');
      }
    } finally {
      loading.destroy();
    }
  }

  private _openAlertModal(msg: string, title = 'Erreur'): void {
    this._modalSrv.openAlert(
      this._viewContainerRef,
      title,
      msg
    );
  }

  private _openHTMLError(htmlContent: string): void {
    const modal = this._modalSrv.openModal<HtmlErrorComponent>(
      this._viewContainerRef,
      HtmlErrorComponent
    ) as ComponentRef<HtmlErrorComponent>;
    modal.instance.htmlContent = htmlContent;
    const sub = modal.instance.closeEmitter.subscribe(() => {
      modal.destroy();
      sub.unsubscribe();
    });
  }

}
